<template>
  <div class="distributor">
    <headline />
    <header class="title">
      <img src="./img/u2835.png" alt />
      <div class="title-popup">
        <h1>经销商伙伴计划</h1>
        <p>经销商伙伴是具有宥马学校体育管理信息化平台销售的售前咨询、销售、服务能力。将产品销售给最终用户的合作伙伴。</p>
      </div>
    </header>
    <main v-if="!submission">
      <p class="main-title">全国招募经销商，欢迎您的加入</p>
      <Form ref="query" :model="query" :rules="ruleInline" :label-width="160" label-position="left">
        <FormItem prop="companyName" label="企业名称:">
          <Input type="text" v-model="query.companyName" />
        </FormItem>
        <FormItem prop="userName" label="联系人:">
          <Input type="text" v-model="query.userName" />
        </FormItem>
        <FormItem prop="phone" label="联系电话:">
          <Input type="text" v-model="query.phone" />
        </FormItem>
        <FormItem prop="license" label="营业执照扫描件:">
          <Input type="text" v-model="query.name" readonly />
          <base-upload class="file-upload" @uploadSuccess="changeActiveImg"></base-upload>
          <!-- <p class="file-upload" @click="upload">点击上传</p> -->
        </FormItem>
        <FormItem>
          <p class="explain">支持：.png.jpg.jpge</p>
        </FormItem>
      </Form>
      <div style="text-align: center;">
        <Button
          type="success"
          style="width: 2.7rem;height: 0.46rem;margin-bottom: 0.4rem;"
          :loading="loading"
          @click="handleReset('query')"
        >提交</Button>
      </div>
    </main>
    <main v-else class="successful">
      <img src="./img/success.png" alt />
      <p>信息提交成功，我们会在48-72小时内与您联系，感谢你的支持！</p>
    </main>
    <foot />
  </div>
</template>

<script>
import headline from "@/components/headline/headline";
import foot from "@/components/foot/foot";
import baseUpload from "@/components/base-upload";
import { apply } from "@/api/request";

export default {
  name: "distributor",
  data() {
    return {
      submission: false,
      loading: false,
      query: {
        companyName: "",
        userName: "",
        phone: "",
        license: "",
        name: ""
      },
      ruleInline: {
        companyName: [
          { required: true, message: "请输入企业名称", trigger: "blur" }
        ],
        userName: [
          { required: true, message: "请输入联系人", trigger: "blur" }
        ],
        phone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: "手机号码格式不正确",
            trigger: "blur"
          }
        ],
        license: [
          { required: true, message: "请上传营业执照扫描件", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    handleReset(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.loading = true;
          this.apply();
          // this.$Message.success("Success!");
        }
      });
    },
    upload() {
      this.$refs.baseUpload.uploadSuccess();
    },
    changeActiveImg(data) {
      this.query.license = data.key;
      this.query.name = data.name;
    },
    apply() {
      apply({
        ...this.query
      }).then(data => {
        if (!data) {
          this.$Message.success("提交成功!");
          this.submission = true;
        }
        setTimeout(() => {
          this.loading = false;
        }, 500);
      });
    }
  },
  components: {
    headline,
    foot,
    baseUpload
  }
};
</script>

<style lang="less" scoped>
header {
  position: relative;
  & > img {
    width: 100%;
    display: block;
  }
  .title-popup {
    width: 7rem;
    position: absolute;
    top: 50%;
    left: 10%;
    transform: translateY(-50%);
    h1 {
      font-size: 0.6rem;
      color: white;
      margin-bottom: 0.2rem;
    }
    p {
      font-size: 0.2rem;
      color: white;
    }
  }
}
main {
  .main-title {
    margin: 0.4rem auto;
    font-size: 36px;
    font-weight: 600;
    text-align: center;
  }
  /deep/.ivu-form {
    width: 7.6rem;
    margin: auto;
    .ivu-form-item-label {
      font-size: 18px;
      font-weight: 600;
      color: #100f0f;
      line-height: 0.4rem;
    }
    .ivu-form-item-content {
      position: relative;
      height: 0.6rem;
      .ivu-input-type-text,
      .ivu-input {
        height: 100%;
      }
      .file-upload {
        position: absolute;
        right: 0.1rem;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
        .ivu-upload {
          margin-top: 0 !important;
        }
        .ivu-upload:focus {
          border: 1px solid white;
        }
        span {
          font-size: 0.16rem;
          font-weight: 600;
          color: rgba(153, 153, 153, 1);
          text-decoration: underline;
        }
      }
    }
    .explain {
      font-size: 16px;
      font-weight: 600;
      color: rgba(153, 153, 153, 1);
    }
  }
}
.successful {
  text-align: center;
  padding: 1.3rem 0;
  & > img {
    margin-bottom: 0.2rem;
  }
  & > p {
    font-size: 0.24rem;
    font-weight: 400;
    color: rgba(34, 34, 34, 1);
  }
}
</style>
